export const isSuccessStatusCode = (code: number) => {
  return code >= 200 && code < 300;
};
